import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import ApiURL from "../../api/ApiURL";
import axios from "axios";
import cogoToast from 'cogo-toast';
import validation from '../../validation/validation';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';

class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btn: 'Save',
            email: '',
            password: '',
            confirmPassword: ''
        };
    }

    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    saveHandler = (e) => {
        e.preventDefault();
        var { email, password, confirmPassword } = this.state;
        if (email === '') {
            cogoToast.error("Please enter Email Id!", { position: 'bottom-center' });
        }
        if (email !== '' && !validation.EmailRegx.test(email)) {
            cogoToast.error("Invalid Email Id!", { position: 'bottom-center' });
        }
        else if (password === '') {
            cogoToast.error("Please enter valid password!", { position: 'bottom-center' });
        }
        else if (confirmPassword === '') {
            cogoToast.error("Please enter confirm password!", { position: 'bottom-center' });
        }
        else if (password !== '' && confirmPassword !== '' && password !== confirmPassword) {
            cogoToast.error("Confirm password does not match!", { position: 'bottom-center' });
        }
        else {
            this.setState({ btn: "Processing.." });
            var param = {
                Email: email,
                Pwd: password
            };
            axios.post(ApiURL.ChangePassword, param).then(response => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    this.setState({ btn: "Save" })
                    cogoToast.success('Password saved successfully !', { position: 'bottom-center' });
                    LocalStorageHelper.removeUser();

                } else if (respData.StatusCode === 400) {
                    this.setState({ btn: "Save" });
                    cogoToast.error(respData.Message, { position: 'bottom-center' });

                } else if (respData.StatusCode === 500) {
                    this.setState({ btn: "Save" });
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: 'bottom-center' });
                }

            }).catch(error => {
                this.setState({ btn: "Save" });
                cogoToast.error("Request Failed! Please Try Again.", { position: 'bottom-center' })
            })
        }
    }

    render() {
        const loginImgURL = ApiURL.BaseImageURL + "/login.webp";
        return (
            <>
                <div className="container">

                    {/* <!-- Outer Row --> */}
                    <div className="row justify-content-center">
                        <div className="col-xl-10 col-lg-12 col-md-9">
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body p-0">
                                    {/* <!-- Nested Row within Card Body --> */}
                                    <div className="row">
                                        <div className="col-lg-6 d-none d-lg-block bg-login-image">
                                            <img src={loginImgURL} alt="..." width="500" />
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="p-5">
                                                <div className="text-center">
                                                    <h1 className="h4 text-gray-900 mb-4">Change Password!</h1>
                                                </div>
                                                <form className="user">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            name="email"
                                                            placeholder="Enter Email Address"
                                                            value={this.state.email}
                                                            onChange={this.onChangeHandler}
                                                            autoComplete='false'
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-user"
                                                            name="password"
                                                            placeholder="Enter New Password"
                                                            value={this.state.password}
                                                            onChange={this.onChangeHandler}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-user"
                                                            name="confirmPassword"
                                                            placeholder="Confirm Password"
                                                            value={this.state.confirmPassword}
                                                            onChange={this.onChangeHandler}
                                                        />
                                                    </div>
                                                    <Link
                                                        to={"/"}
                                                        className="btn btn-primary btn-user btn-block"
                                                        onClick={this.saveHandler}>
                                                        {this.state.btn}
                                                    </Link>
                                                    <hr />
                                                    <div className="text-center">
                                                        <Link to={"/"} className="small">User Sign in</Link>
                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ForgetPassword;